import { createAction, props } from '@ngrx/store';

export const UpdateConfigVersionState = createAction('[UpdateConfigVersionState] Update UpdateConfigVersion props', props<{ payload }>());
